import { Link } from 'react-router-dom';
import { formatPayoutCutoffDate, formatYearMonthLong } from '../utils/dateFormat';
import { formatInr } from '../utils/withdrawalTds';

/**
 * Member-facing: wallet total is not the same as this month's bank transfer.
 */
export default function PayoutWalletNote({ snapshot, showWithdrawalsLink = true }) {
  const leftover = Number(snapshot?.wait_next_cycle_points ?? 0);
  const thisPts = Number(snapshot?.this_cycle_points ?? 0);
  const net = snapshot?.this_cycle_net;
  const cutoff = snapshot?.cutoff_date
    ? formatPayoutCutoffDate(snapshot.cutoff_date)
    : snapshot?.cutoff_at
      ? formatPayoutCutoffDate(snapshot.cutoff_at)
      : '';
  if (!snapshot || thisPts <= 0) return null;

  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 space-y-1.5">
      <p className="text-sm font-semibold text-amber-950">
        {Number(snapshot.wallet_points).toLocaleString('en-IN')} pts is your full wallet — not this
        month&apos;s bank transfer.
      </p>
      <p className="text-sm text-amber-900/90 leading-relaxed">
        This payout includes {thisPts.toLocaleString('en-IN')} pts
        {cutoff ? ` earned till ${cutoff}` : ''}
        {snapshot.payout_month ? ` (${formatYearMonthLong(snapshot.payout_month)})` : ''}. You
        receive ₹{formatInr(net)} after 5% tax.
        {leftover > 0
          ? ` ${leftover.toLocaleString('en-IN')} pts${cutoff ? ` after ${cutoff}` : ''} stay in your wallet for the next payout.`
          : ' Nothing is waiting for next month.'}
      </p>
      {showWithdrawalsLink ? (
        <Link to="/withdrawal" className="inline-block text-sm font-semibold text-violet-700 underline">
          See payout details
        </Link>
      ) : null}
    </div>
  );
}
